import { Route, Routes } from 'react-router-dom'
import { Layout } from 'features/layout'
import { routes } from 'core/routes/paths'
import { ProtectedRoute } from '../components/ProtectedRoute'
import MainPage from 'pages/main/page'
import TasksPage from 'pages/tasks/page'
import FriendsPage from './friends/page'
import GamesPage from './games/page'
import AdventPage from './advent/page'
import MinesPage from './mines/page'
import ProfilePage from './profile/page'
import HistoryPage from './history/page'
import BattlePage from './battle/page'
import DesktopPage from './desktop/page'
import AdminPage from './admin/page'
import AdminStatsPage from './admin/stats/page'
import AdminCasesPage from './admin/cases/page'
import AdminAdventPage from './admin/advent/page'
import AdminUsersPage from './admin/users/page'
import AdminTasksPage from './admin/tasks/page'
import AdminReferralsPage from './admin/referrals/page'
import AdminMarketingPage from './admin/marketing/page'
import AdminMinesPage from './admin/mines/page'
import AdminBattlesPage from './admin/battles/page'
import AdminTriggersPage from './admin/triggers/page'
import AdminLeaderboardPage from './admin/leaderboard/page'
import EarningsPage from './earnings/page'
import LeaderboardPage from './leaderboard/page'
import FaqPage from './faq/page'
import UserProfilePage from './user-profile/page'

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path={routes.desktop} element={<DesktopPage />} />

            <Route element={<Layout />}>
                <Route path={routes.main} element={<MainPage />} />
                <Route
                    path={routes.tasks}
                    element={
                        <ProtectedRoute>
                            <TasksPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.friends}
                    element={
                        <ProtectedRoute>
                            <FriendsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.earnings}
                    element={
                        <ProtectedRoute>
                            <EarningsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.leaderboard}
                    element={
                        <ProtectedRoute>
                            <LeaderboardPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.faq}
                    element={
                        <ProtectedRoute>
                            <FaqPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.userProfile}
                    element={
                        <ProtectedRoute>
                            <UserProfilePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.games}
                    element={
                        <ProtectedRoute>
                            <GamesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.advent}
                    element={
                        <ProtectedRoute>
                            <AdventPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.mines}
                    element={
                        <ProtectedRoute>
                            <MinesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.profile}
                    element={
                        <ProtectedRoute>
                            <ProfilePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.history}
                    element={
                        <ProtectedRoute>
                            <HistoryPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.battle}
                    element={
                        <ProtectedRoute>
                            <BattlePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.admin}
                    element={
                        <ProtectedRoute>
                            <AdminPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminStats}
                    element={
                        <ProtectedRoute>
                            <AdminStatsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminCases}
                    element={
                        <ProtectedRoute>
                            <AdminCasesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminAdvent}
                    element={
                        <ProtectedRoute>
                            <AdminAdventPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminUsers}
                    element={
                        <ProtectedRoute>
                            <AdminUsersPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminTasks}
                    element={
                        <ProtectedRoute>
                            <AdminTasksPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminReferrals}
                    element={
                        <ProtectedRoute>
                            <AdminReferralsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminMarketing}
                    element={
                        <ProtectedRoute>
                            <AdminMarketingPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminMines}
                    element={
                        <ProtectedRoute>
                            <AdminMinesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminBattles}
                    element={
                        <ProtectedRoute>
                            <AdminBattlesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminTriggers}
                    element={
                        <ProtectedRoute>
                            <AdminTriggersPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={routes.adminLeaderboard}
                    element={
                        <ProtectedRoute>
                            <AdminLeaderboardPage />
                        </ProtectedRoute>
                    }
                />
            </Route>
        </Routes>
    )
}
